export default __webpack_public_path__ + "static/media/UBXT-BUSD.419ca4fb.svg";